import { BZG_MODAL_DATA, BzgModalRef } from "bz-genome-angular";
import { Component, HostListener, Inject } from "@angular/core";
import { TraceService } from "app/trace-management/core/services/trace.service";
import { DateUtil } from "../../../core/utils/DateUtil";
import { IGenomeTime } from "bz-genome-angular/time-picker/time-picker/bzg-time-picker.component";
import { GenomeTimeService } from "app/shared/services/genome-time.service";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { I18nService } from "i18n/i18n.service";
import * as $ from 'jquery';

enum TypeFileEnum {
  // xml = "xml",
  // json = "json"
}

@Component({
  selector: "modalViewerDetail",
  styleUrls: ["./modal-viewer-detail.component.scss"],
  templateUrl: "./modal-viewer-detail.component.html"
})
export class ModalViewerDetailComponent {
  public onDate: Date = new Date();
  public onTime: IGenomeTime;
  public isChangingDateManually = true;
  public isChangingTime = false;
  public maxDate = new Date();
  public previousTime: IGenomeTime;
  public contentEntries: Array<IBATraceDetail>;
  public contentEntriesCustom: Array<any>;
  public showLoading: boolean;
  public continuationToken: string;
  public hasMoreResults: boolean = false;
  public showSelection: boolean = false;
  public loadingMessage: string = '';
  public traceFilter: ITraceFilter;

  private selectedEntries: Array<IBATraceDetail> = [];
  private typeFile: string;
  private state = { dateMin: new Date(), dateMax: new Date() };
  private _timeChanged = new Subject<any>();
  private lineBreakCorrect = /\r\n/g;
  private dateRegexFormat1 = /([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})\s([0-9]{1,2})\:([0-9]{1,2})\:([0-9]{1,2})\s([amp,AMP]{2})/g; // dd/mm/yyyy hh:MM:ss am
  private dateRegexFormat2 = /([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})\s([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}).([0-9]{1,3})/g; //yyyy-mm-dd hh:MM:ss.sss
  private dateRegexFormat3 = /\r\n([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})\s([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}).([0-9]{1,3})/g;  //carry yyyy-mm-dd hh:MM:ss.sss
  @HostListener("click", ["$event"])
  onClick(btn) {
    const path = btn.path || (btn.composedPath && btn.composedPath());
    if (path.some((item: HTMLElement) => item.tagName && item.tagName.toLocaleLowerCase() === "bzg-time-picker")) {
      if (path[0].className.baseVal === "bz-time-picker__arrows__item" || (path[1] && path[1].className.baseVal === "bz-time-picker__arrows__item")) {
        this.changeTime(path);
        this._timeChanged.next();
      }
      else if( path && path[0] && path[0].className === "bz-btn bz-btn--secondary bz-time-picker__period"){
        this._timeChanged.next();
      }

    }
  }



  constructor(public modalComponentRef: BzgModalRef, private _traceService: TraceService,
              @Inject(BZG_MODAL_DATA) public data: { entry: IBATraceFile },
              private _genomeTimeService: GenomeTimeService,
              private _i18nService: I18nService) {
    this.typeFile = data.entry.Name.substr(data.entry.Name.lastIndexOf(".") + 1);
    this._timeChanged.pipe(
      debounceTime(1000)).subscribe(async () => {
      this.isChangingTime = true;
      this.changeDate();
    });
  }

  ngOnInit() {
    this.getTraceData();
    this.previousTime = _.clone(this.onTime);
  }

  ngOnDestroy() {
    $(".bmc-modal-viewer-detail__message > b").off("click");
    $(".bmc-modal-viewer-detail__message > b svg").off("click");

  }

  public onTimeChange() {
    this._timeChanged.next();
  }

  close() {
    this.modalComponentRef.close();
  }

  public downloadFile() {
    this.showLoading = true;
    this.loadingMessage = `${this._i18nService.instant('TRACE.DOWNLOAD')} ${this.data.entry.Name}`;

    if (!this.isTypeFileSelectable()) {
      this.selectedEntries =  this.contentEntries;
    }

    this._traceService.downloadBatchTraceFile(this.selectedEntries.map((value) => {
      return {
        category: this.data.entry.Category,
        name: value.PartitionKey,
        rowKey: value.RowKey,
        endDate: this.onDate
      };
    }))
      .subscribe(() => {
        this.showLoading = false;
      });
  }

  public isTypeFileSelectable() {
    return (<any>Object).values(TypeFileEnum).includes(this.typeFile);
  }

  public isDisabled() {
    if (this.isTypeFileSelectable()) {
      return !(this.contentEntries && this.contentEntries.length && this.selectedEntries && this.selectedEntries.length);
    }
    else if (!this.isTypeFileSelectable()) {
      return !(this.contentEntries && this.contentEntries.length);
    }
  }

  public loadResults(type: string) {
    if (type === "later") {
      this.getTraceData();
    }
  }

  public changeDate() {
    if (!this.isChangingDateManually) {
      this.contentEntries = [];
      this.traceFilter.endDate = this.onDate;
      this._genomeTimeService.setTimeToDate(this.traceFilter.endDate, this.onTime);
      this.showLoading = true;
      this.loadingMessage = `${this._i18nService.instant('TRACE.LOADING')}`;
      this._traceService.getFileDetails(this.traceFilter)
        .subscribe((result: IFilterResult) => {
          this.continuationToken = result.ContinuationToken;
          if (!this.contentEntries) {
            this.contentEntries = [];
          }
          this.groupResponsesOfSameLog(this.contentEntries, result.Results);
          this.showLoading = false;
          this.isChangingTime = false;

          this.contentEntriesCustom = [];
          this.lineBreak();
          this.hasMoreResults = result.HasMoreResults;
        });
    }
  }

  public setSelectedEntries(entries) {
    this.selectedEntries = entries;
  }

  public filterEventLogs(dateFilter: any) {
    this.contentEntries = [];
    // Update state
    this.state = {
      dateMin: DateUtil.getFirstDayTime(dateFilter.start),
      dateMax: DateUtil.getLastDayTime(dateFilter.end)
    };
    this.continuationToken = "";
    this.getTraceData();
  }

  private getTraceData() {
    this.initializeTraceDetailFilter();
    if (this.showSelection)
      this.traceFilter.filterProperties.pageSize = 1000;
    this.showLoading = true;
    this.loadingMessage = `${this._i18nService.instant('TRACE.LOADING')} ${this.data.entry.Name}`;
    this._traceService.getFileDetails(this.traceFilter)
      .subscribe((result: IFilterResult) => {
        this.continuationToken = result.ContinuationToken;
        if (!this.contentEntries) {
          this.contentEntries = [];
        }
        if (this.showSelection)
          this.groupResponsesOfSameLog(this.contentEntries,  result.Results.reverse());
        else
          this.groupResponsesOfSameLog(this.contentEntries, result.Results);
        this.contentEntriesCustom = [];
        this.lineBreak();
        this.showLoading = false;
        this.isChangingDateManually = false;
        this.hasMoreResults = result.HasMoreResults;
      });
  }

  private lineBreak() {
    if (this.contentEntries) {
      if (this.contentEntries.length === 1)
        this.lineBreakDate(this.contentEntries[0], 0, false);
      else {
        for (let i = 0; i < this.contentEntries.length; i ++) {
          this.lineBreakDate(this.contentEntries[i], i, true);
        }
      }
    }
  }

  lineBreakDate(contentEntry, position, apply) {
    if (contentEntry.MessageLog) {
      let pushItem = false;
      if(!(contentEntry.MessageLog&&contentEntry.Timestamp&&!contentEntry.Timestamp.match(this.dateRegexFormat2)))
        pushItem = this.lineBreakByFormat(contentEntry.MessageLog, this.dateRegexFormat2);

      if (contentEntry.PartitionKey.toLocaleLowerCase() === 'scheduler')
        this.lineBreakMoreInfo(contentEntry, position, apply);

      if (!pushItem)
      {
        this.contentEntriesCustom.push({
          Timestamp: this.timestampCustom(contentEntry.Timestamp),
          MessageLog: contentEntry.MessageLog
        });
      }
    }
  }

  lineBreakMoreInfo(contentEntry, position, apply) {
    let moreInfo = 'None     INFO SCHEDULER';
    if (contentEntry.PartitionKey.toLocaleLowerCase() === 'scheduler') {
      const repetitionsMoreInfo = this.countRepetitions(contentEntry.MessageLog, moreInfo);
      if (repetitionsMoreInfo && repetitionsMoreInfo.length > 1 && apply) {
        for (let i = 0; i < repetitionsMoreInfo.length; i ++) {
          const substrMessageLog = contentEntry.MessageLog.substring(repetitionsMoreInfo[i].length);
          const indexNextMoreInfoRegex = substrMessageLog.search(moreInfo);
          let MessageLog = '';

          if (indexNextMoreInfoRegex > 0) {
            MessageLog = contentEntry.MessageLog.substring(0, indexNextMoreInfoRegex + repetitionsMoreInfo[i].length);
            contentEntry.MessageLog = contentEntry.MessageLog.substring(indexNextMoreInfoRegex + repetitionsMoreInfo[i].length);
          }
          else
            MessageLog = contentEntry.MessageLog;

          let element = {
            MessageLog,
            PartitionKey: contentEntry.PartitionKey,
            RowKey: contentEntry.RowKey,
            Timestamp: contentEntry.Timestamp
          };

          this.contentEntries.splice(position + i, 0, element);
        }
      }
    }
  }

  countRepetitions(text, lookFor) {
    const regex = new RegExp(lookFor, 'g');
    return text.match(regex);
  }

  private lineBreakByFormat(messageLog, dateRegexFormat) {
    let pushItem = false;
    const countDateRegex = messageLog.match(dateRegexFormat);
    if(countDateRegex) {
      for (let i = 0; i < countDateRegex.length; i++) {
        let invalidString1 = '\'' + countDateRegex[i] + '\'';
        let invalidString2 = countDateRegex[i] + ']';
        let invalidString3 = '>' + countDateRegex[i] + '<';
        if (!messageLog.includes(invalidString1) && !messageLog.includes(invalidString2) && !messageLog.includes(invalidString3)) {
          const indexDateRegex = messageLog.search(dateRegexFormat);
          const substrMessageLog = messageLog.substring(indexDateRegex + countDateRegex[i].length);
          const indexNextDateRegex = substrMessageLog.search(dateRegexFormat);
          let MessageLog = '';

          if (indexNextDateRegex > 0)
            MessageLog = substrMessageLog.substring(0, indexNextDateRegex);
          else
            MessageLog = substrMessageLog;

          this.contentEntriesCustom.push({
            Timestamp: this.timestampCustom(countDateRegex[i]),
            MessageLog
          });
          messageLog = messageLog.substring(indexNextDateRegex + indexDateRegex);
          pushItem = true;
        }
      }
    }
    return pushItem;
  }

  private timestampCustom(timestampIn) {
    let Timestamp = '';
    let indexDot = timestampIn.indexOf('.');
    let subStr = timestampIn.substring(indexDot);
    let addZeros = '';

    if (subStr && subStr.length < 14) {
      for (let i = 1; i <= 14 - subStr.length; i++) {
        addZeros += '0';
      }
      Timestamp = timestampIn.substring(0, indexDot + 8 - addZeros.length) +
        addZeros + timestampIn.substring(indexDot + 8 - addZeros.length );
    }
    else
      Timestamp = timestampIn;

    return Timestamp;
  }

  private attachFoldEvent() {
    const messageContainer = $(".bmc-modal-viewer-detail__message");
    $("> b", messageContainer).off("click");
    $("> b", messageContainer).on("click", (event) => {
      const parent = $(event.target.parentElement);
      $("> b svg", parent).css(
        "transform",
        $("> div", parent).css("display") === "none" ? "none" : "rotateX(180deg)"
      );
      $("> div", parent).slideToggle();
    });

    $("> b svg", messageContainer).off("click");
    $("> b svg", messageContainer).on("click", (event) => {
      const parent = $(event.target.parentElement.parentElement);
      $("> b svg", parent).css(
        "transform",
        $("> div", parent).css("display") === "none" ? "none" : "rotateX(180deg)"
      );
      $("> div", parent).slideToggle();
    });
  }

  private changeTime(path: Array<HTMLElement>) {
    if (path[0].tagName.toLowerCase() !== "button") {
      const arrow = this.getPressedArrow(path[0]);
      const valueSection = path[this.getNumSection(path[0])].children[0]["value"];
      const timeSection = this.getTimeSection(path);
      const resultIsTimeReset = this.isTimeReset(arrow, timeSection, this.previousTime[timeSection]);

      if (arrow !== null && resultIsTimeReset) {
        const newValue = arrow === "up" ? 0 : timeSection === "hours" ? 12 : 59;
        this.onTime[timeSection] = newValue;
        path[this.getNumSection(path[0])].children[0]["value"] = newValue === 0 ? "00" : newValue.toString();
      }
      else if (!resultIsTimeReset) {
        let value = parseInt(path[this.getNumSection(path[0])].children[0]["value"], 10);
        let newValue = arrow === "up" ? value + 1 : value - 1;
        newValue = Math.abs(this.previousTime[timeSection] - newValue) == 2 ? value : newValue < 0 ? timeSection === "hours" ? 12 : 59 : newValue;
        this.onTime[timeSection] = newValue;
        path[this.getNumSection(path[0])].children[0]["value"] = newValue < 10 ? "0" + newValue : newValue.toString();
      }
    }

    this.previousTime = _.clone(this.onTime);
  }

  private isTimeReset(arrow, timeSection, valueSection) {
    return (arrow === "up" && ((timeSection === "hours" && valueSection === 12) || valueSection === 59)) ||
      (arrow === "down" && valueSection === 0);
  }

  private getTimeSection(path: Array<HTMLElement>): string {
    const numSection = this.getNumSection(path[0]);
    const previous = path[numSection].previousElementSibling;
    const next = path[numSection].nextElementSibling;

    return previous === null ? "hours" : next.tagName.toLowerCase() === "button" ? "seconds" : "minutes";
  }

  private getNumSection(item: HTMLElement) {
    return item.tagName === "use" ? 3 : 2;
  }

  private getPressedArrow(item: HTMLElement): string {
    let result = null;

    if (item.tagName === "use" || item.tagName === "svg") {
      const value = item.tagName === "use" ? item["href"].baseVal : item.children[0]["href"].baseVal;

      if (value === "#icon-chevron-up") {
        result = "up";
      }
      else if (value === "#icon-chevron-down") {
        result = "down";
      }
    }

    return result;
  }

  private initializeTraceDetailFilter() {
    this.traceFilter = {
      filterProperties: {
        pageSize: 100,
        continuationToken: this.continuationToken,
        sort: "Desc"
      } as IFilterProperties,
      name: this.data.entry.Name,
      category: this.data.entry.Category,
      startDate: null,
      endDate: DateUtil.getLastDayTime(this.state.dateMax)
    };
    this.onTime = this._genomeTimeService.getTimeFromDate(this.traceFilter.endDate);
  }

  private isLongString(beforeValue, actualValue, character) {
    return actualValue.MessageLog.length == 10000 && actualValue.RowKey.includes(character) &&
      actualValue.RowKey.split(character)[0] === beforeValue.RowKey.split(character)[0];
  }

  private groupResponsesOfSameLog(results: Array<IBATraceDetail>, newValues: Array<IBATraceDetail>) {
    if (!newValues || !newValues.length) {
      return;
    }

    let groups = [[newValues[0]]];
    let j = 0;

    for (let index = 1; index < newValues.length; index++) {
      if (this.isLongString(newValues[index - 1], newValues[index],  ';') ||
        this.isLongString(newValues[index - 1], newValues[index],  '-')) {
        groups[j].unshift(newValues[index]);
        continue;
      }
      groups[++j] = [newValues[index]];
    }

    for (let i = 0; i < groups.length; i++) {
      results.push(groups[i][0]);
      const resultActualPosition = results.length - 1;
      let isLimit = false;
      let countLines = 0;

      for (let j = 1; j < groups[i].length; j++) {
        const element = groups[i][j];
        countLines += element.MessageLog ? element.MessageLog.split("\n").length : 0;
        results[resultActualPosition].RowKey += `,${element.RowKey}`;

        if (countLines <= 100) {
          results[resultActualPosition].MessageLog += element.MessageLog;
        }
        else if (!isLimit) {
          results[resultActualPosition].MessageLog += element.MessageLog;
          isLimit = true;
        }
      }
    }

    setTimeout(() => {
      this.attachFoldEvent();
    }, 0);
  }

  changeSelection() {
    this.contentEntries = [];
    this.contentEntriesCustom = [];
    this.continuationToken = null,
    this.getTraceData();
  }

  downloadAll() {
    this.showLoading = true;
    this.loadingMessage = `${this._i18nService.instant('TRACE.DOWNLOAD')} ${this.data.entry.Name}`;
    this._traceService.downloadTraceFile(this.data.entry)
      .subscribe(() => {
        this.showLoading = false;
    });
  }

}
